<script>
import ModbusRtuChannel from '@/helpers/ModbusRtuChannel';
import VBusChannel from '@/helpers/VBusChannel';
import { OnionRpcChannel } from '@/helpers/OnionRpc/OnionRpcChannel';

export default {
  methods: {
    initializeCommunication() {
      for (let index = 0; index < this.uarts.length; index++) {
        const uart = this.uarts [index];
        if (uart.kind === 'VBus') {
          const channel = new VBusChannel(`UART${index}`, (data) => {
            this.bridge.sendUartData(index, data);
          });
          const vbusData = {
            channel: index,
            packets: [],
            datagrams: [],
            telegrams: [],
          };
          channel.on('telegram', (telegram) => {
            if (!telegram.timestamp) {
              telegram.timestamp = new Date();
            }
            const channelTelegram = vbusData.telegrams.find(x =>
              x.destinationAddress === telegram.destinationAddress
              && x.sourceAddress === telegram.sourceAddress
              && x.protocolVersion === telegram.protocolVersion
              && x.command === telegram.command
            );
            if (!channelTelegram) {
              vbusData.telegrams.push(telegram);
            } else {
              this.$set(channelTelegram, 'frameData', telegram.frameData);
              this.$set(channelTelegram, 'timestamp', telegram.timestamp);
            }
          });
          channel.on('datagram', (datagram) => {
            
            if (!datagram.timestamp) {
              datagram.timestamp = new Date();
            }
            const channelDatagram = vbusData.datagrams.find(x =>
              x.destinationAddress === datagram.destinationAddress
              && x.sourceAddress === datagram.sourceAddress
              && x.protocolVersion === datagram.protocolVersion
              && x.command === datagram.command
              && x.valueId === datagram.valueId
            );
            if (!channelDatagram) {
              vbusData.datagrams.push(datagram);
            } else {
              this.$set(channelDatagram, 'value', datagram.frameData);
              this.$set(channelDatagram, 'timestamp', datagram.timestamp);
            }
          });
          channel.on('packet', (packet) => {
            if (!packet.timestamp) {
              packet.timestamp = new Date();
            }
            const channelPacket = vbusData.packets.find(x =>
              x.destinationAddress === packet.destinationAddress
              && x.sourceAddress === packet.sourceAddress
              && x.protocolVersion === packet.protocolVersion
              && x.command === packet.command
            );
            if (!channelPacket) {
              vbusData.packets.push(packet);
            } else {
              this.$set(channelPacket, 'frameData', packet.frameData);
              this.$set(channelPacket, 'timestamp', packet.timestamp);
            }
          });
          this.$set(uart, 'channel', channel);
          this.$set(uart, 'vbusData', vbusData);
        } else if (uart.kind === 'ModbusRtu') {
          const channel = new ModbusRtuChannel(`UART${index}`, (data) => {
            this.bridge.sendUartData(index, data);
          });

          this.$set(uart, 'channel', channel);
        } else if (uart.kind === 'RPC') {
          const channel = new OnionRpcChannel(uart.name || `RPC_${index}`, (data) => {
            this.bridge.sendUartData(index, data);
          });
          const rpcData = {
            messages: [],
          };

          channel.on('onionRpcUnexpectedMessage', (data) => {
            rpcData.messages.push({
              timestamp: new Date(),
              ...data,
            });
            if (rpcData.messages.length > 20) {
              rpcData.messages.splice(0, rpcData.messages.length - 20);
            }
          });
          channel.on('onionRpcMessage', (data) => {
            rpcData.messages.push({
              timestamp: new Date(),
              ...data,
            });
            if (rpcData.messages.length > 20) {
              rpcData.messages.splice(0, rpcData.messages.length - 20);
            }
          });

          this.$set(uart, 'channel', channel);
          this.$set(uart, 'rpcData', rpcData);
        }
      }

      this.bridge.on('uartDidReceive', (index, data) => {
        const uartChannel = this.uarts[index].channel;
        if (uartChannel) {
          for (const b of data) {
            uartChannel.receiveData(b);
          }
        }
      });
    }
  },
};
</script>
